import { ICategoryProducts } from '../../interfaces';
import { CountryCode } from '../../lib/constants';
import styles from './DesignCategory.module.css';
import { Pagination } from '../shared/pagination';
import { ProductTile } from './ProductTile';
import Image from 'next/image'
import { useState } from 'react';
import { API } from '@/lib/helpers/http-client';
import { useGlobalContext } from '@/lib/context';
import { DesignWidget } from './DesignWidget';
import React from 'react';
import { TrendsWidget } from '../shared/widgets/trendsWidget';
import { DesignCatsNewWidgets } from './DesignCatsNewWidgets';
import designIdeaWidgetsData from "../../data/designIdeaWidgets.json";
import { MarketPlaceCatWidget } from '../marketplace/marketplaceWidget';
import { FreeEstimateWidget } from './FreeEstimateWidget';
import { MkCostCalculatorWidget } from './MkCostCalculatorWidget';
type Props = {
    data: ICategoryProducts;
    categorySlug: string;
    atrIdentifier?: string;
};

const referAndEarnData = {
    image: "refer&earn.svg",
    text: `<p class="font20 lineHeight26 text000 fbold">Refer to family and friends <br> <span class="textpink">Earn ₹10,000</span> with every referral</p>`,
    buttonText: "Speak to an Expert",
    cssClass: "refer"
};

export function DesignProduct({ data, atrIdentifier, categorySlug }: Props) {
    const [items, setItems] = useState(data.products);
    const { props: { pageURL } } = useGlobalContext();
    const isSearch = pageURL.includes('/search?');
    const { filterWidget, widgetData, similarWidgetData, latestPosts: trendsWidget } = data;
    const designWidgetData = designIdeaWidgetsData.find((f) => f.categorySlug === categorySlug)?.data || [];
    const withReferAndEarn = [...designWidgetData, referAndEarnData];
    const fetchMoreData = async (nextPage: number) => {
        const body = {
            categorySlug,
            countryCode: CountryCode.INR,
            atrIdentifier: atrIdentifier || "",
            pageNo: nextPage,
            pageSize: 29,
            isSearch
        };
        const resultProducts = await API.post('/api/productsbyattributes', body);
        if (resultProducts.data?.products?.length > 0) {
            setItems(prevItems => [...prevItems, ...resultProducts.data.products]);
        }
    };

    if (!data?.products?.length) {
        return (
            <div className='noDataFoundImg'>
                <figure className='noDataFoundFig'>
                    <Image src={'/assets/images/no-data-found.svg'} alt='no-data-found' width={425} height={340} className='imgFluid' />
                </figure>
            </div>
        );
    }

    const renderContent = () => {
        const content: any = [];
        let widgetCount = 0;
        const isModularKitchen = pageURL.includes('/modular-kitchen');
        const isNewWidgetPages = pageURL.includes('/modular-kitchen') || pageURL.includes('/wardrobe') || pageURL.includes('/tv-units') || pageURL.includes('/false-ceiling') || false;
        items.forEach((product, index) => {
            content.push(<ProductTile product={product} index={index} key={`product-${index}`} />);
            const positionInPage = (index % 29) + 1;
            if (isModularKitchen) {
                { isNewWidgetPages && positionInPage === 7 && content.push(<FreeEstimateWidget key={`freeEstimate-${index}`} isPopup={isNewWidgetPages} categorySlug={categorySlug} />); }
                positionInPage === 14 && content.push(<MkCostCalculatorWidget key={`mkCostCalculator-${index}`} />);
                positionInPage === 21 && content.push(<FreeEstimateWidget key={`freeEstimate-${index}`} />);
            } else {
                { isNewWidgetPages && positionInPage === 7 && content.push(<FreeEstimateWidget key={`freeEstimate-${index}`} categorySlug={categorySlug} isPopup={isNewWidgetPages} />); }
                positionInPage === 14 && content.push(<FreeEstimateWidget key={`freeEstimate-${index}`} />);
            }
            if (withReferAndEarn.length > 0 && widgetCount < 4 && positionInPage > (isModularKitchen ? isNewWidgetPages ? 14 : 21 : isModularKitchen ? 7 : 14) && positionInPage % 7 === 0) {
                const widgetIndex = widgetCount % withReferAndEarn.length;
                content.push(<DesignCatsNewWidgets key={`NewWidgets-${index}`} widgetData={withReferAndEarn[widgetIndex]} />);
                widgetCount++;
            }
            if (positionInPage === 29) {
                widgetCount = 0;
            }
        });
        return content;
    };

    const renderWidgets = (content: JSX.Element[]) => {
        const finalContent: any = [];
        let trendsWidgetCount = 0;
        const showWidgetIndex = [5, 11, 17];
        const widgetDataToUse = [filterWidget, widgetData, similarWidgetData];
        content.forEach((item, index) => {
            finalContent.push(item);
            if (showWidgetIndex.includes(index)) {
                const widgetIndex = showWidgetIndex.indexOf(index);
                finalContent.push(<DesignWidget key={`widget-${index}`} widgetData={widgetDataToUse[widgetIndex] || filterWidget} />);
            } else if (index === content.length - 1) {
                showWidgetIndex.forEach((targetIndex, widgetIndex) => {
                    if (content.length <= targetIndex) {
                        finalContent.push(
                            <DesignWidget
                                key={`widget-${targetIndex}`}
                                widgetData={widgetDataToUse[widgetIndex] || filterWidget}
                            />
                        );
                    }
                });
            }
            if (index === (items.length < 29 ? items.length - 1 : 29)) {
                finalContent.push(<TrendsWidget key={`trends-${index}`} data={trendsWidget} />);
                trendsWidgetCount++;
            }
        });

        return finalContent;
    };
    const content = renderContent();
    const finalContent = renderWidgets(content);

    return (
        <>
            <div className={styles.modularGrid}>
                {finalContent}
            </div>
            <Pagination TotalPageCount={data.pagingData.totalRows / data.pagingData.pageSize} fetchMoreData={fetchMoreData} />
        </>
    );
}